import React from 'react';
import { Link, useOutletContext } from 'react-router-dom';

const Home = () => {
  const { openQuote } = useOutletContext();

  return (
    <>
      {/* ---------------------------------------------------- Split hero --- */}
      <section className="op-hero">
        <div className="op-container op-hero-grid">
          <div className="op-hero-copy">
            <span className="op-pill"><span className="op-dot" /> Built for anaesthetists</span>
            <h1>The admin behind every case, <span className="op-grad-text">handled.</span></h1>
            <p className="op-hero-lede">
              OmniPrac runs your whole day — scheduling, pre-op risk, ICD-10 coding, time-based
              billing, claims and collections — so you spend less time on paperwork and get paid faster.
            </p>
            <div className="op-hero-actions">
              <button type="button" className="op-btn op-btn-primary op-btn-lg" onClick={openQuote}>Request a Quote</button>
              <Link to="/login" className="op-btn op-btn-ghost op-btn-lg">Client Login</Link>
            </div>
            <div className="op-hero-trust">
              <span className="op-check">✓</span> Time-based billing &nbsp;·&nbsp; automatic modifiers &nbsp;·&nbsp; POPIA-aligned
            </div>
          </div>

          {/* CSS product mockup */}
          <div className="op-mock">
            <div className="op-mock-card">
              <div className="op-mock-bar"><i /><i /><i /><span>omniprac · today’s list</span></div>
              <div className="op-mock-head">
                <h4>Theatre Schedule</h4>
                <em>Netcare · 3 cases</em>
              </div>
              <div className="op-mock-row">
                <div className="op-mock-av">JM</div>
                <div><b>J. Meyer · Lap chole</b><small>07:30 · Dr Naidoo</small></div>
                <span className="op-mock-tag green">Billed</span>
              </div>
              <div className="op-mock-row">
                <div className="op-mock-av">SP</div>
                <div><b>S. Pillay · Arthroscopy</b><small>09:15 · Dr Botha</small></div>
                <span className="op-mock-tag amber">In theatre</span>
              </div>
              <div className="op-mock-row">
                <div className="op-mock-av">AK</div>
                <div><b>A. Khan · C-section</b><small>11:00 · after-hours +50%</small></div>
                <span className="op-mock-tag blue">Pre-op</span>
              </div>
              <div className="op-mock-foot">
                <div><div className="lbl">Units captured today</div><div className="val">142</div></div>
                <div style={{ textAlign: 'right' }}><div className="lbl">Claims ready</div><div className="val">8</div></div>
              </div>
            </div>
            <div className="op-badge-float">
              <span className="ic">⏱️</span>
              <div><b>Induction → handover</b><small>units calculated automatically</small></div>
            </div>
          </div>
        </div>
      </section>

      {/* ---------------------------------------------------- Stat band --- */}
      <section className="op-stats">
        <div className="op-container op-stats-inner">
          <div className="op-stat"><b>1 diary</b><span>Every hospital &amp; surgical team in one view</span></div>
          <div className="op-stat"><b>0 missed units</b><span>Time captured from induction to handover</span></div>
          <div className="op-stat"><b>Faster paid</b><span>Claims scrubbed before they’re submitted</span></div>
        </div>
      </section>

      {/* --------------------------------------------------- Bento grid --- */}
      <section className="op-section op-section-tint" id="features">
        <div className="op-container">
          <div className="op-head">
            <span className="op-kicker">Built for the specialty</span>
            <h2>The hard part isn’t scheduling — it’s billing</h2>
            <p>Organising a diary is easy. Billing an anaesthetist correctly is not. OmniPrac is engineered around exactly that.</p>
          </div>
          <div className="op-bento">
            <div className="op-tile op-tile-lg">
              <div className="op-tile-ic">⏱️</div>
              <h3>Time-based billing engine</h3>
              <p>Purpose-built for anaesthesia: minutes from induction to handover become the correct units and South African tariff codes — automatically, with no manual maths.</p>
            </div>
            <div className="op-tile">
              <div className="op-tile-ic">➕</div>
              <h3>Automatic modifiers</h3>
              <p>BMI, emergency, after-hours and neonate modifiers applied before a claim leaves your hands.</p>
            </div>
            <div className="op-tile">
              <div className="op-tile-ic">🔌</div>
              <h3>Switch integration</h3>
              <p>Claims routed through clearinghouse switches with real-time validation and status.</p>
            </div>
            <div className="op-tile op-tile-teal">
              <div className="op-tile-ic">📅</div>
              <h3>Cross-hospital scheduling</h3>
              <p>One calendar across every hospital and team — patients, comorbidities and codes attached to each case.</p>
            </div>
            <div className="op-tile">
              <div className="op-tile-ic">🛡️</div>
              <h3>Secure &amp; POPIA-aligned</h3>
              <p>Encrypted data, per-practice isolation and role-based access with a full audit trail.</p>
            </div>
          </div>
        </div>
      </section>

      {/* ------------------------------------------------------- CTA --- */}
      <section className="op-ctablock">
        <div className="op-container">
          <div className="op-cta">
            <h2>Reclaim the hours you lose to admin.</h2>
            <p>Every practice is different — we’ll tailor OmniPrac and your pricing to how you actually work.</p>
            <div className="op-hero-actions">
              <button type="button" className="op-btn op-btn-primary op-btn-lg" onClick={openQuote}>Request a Quote</button>
              <Link to="/login" className="op-btn op-btn-soft op-btn-lg">Client Login</Link>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Home;
